import { render, staticRenderFns } from "./appliedLabels.vue?vue&type=template&id=2c886e2c&scoped=true&"
import script from "./appliedLabels.vue?vue&type=script&lang=js&"
export * from "./appliedLabels.vue?vue&type=script&lang=js&"
import style0 from "./appliedLabels.vue?vue&type=style&index=0&id=2c886e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c886e2c",
  null
  
)

export default component.exports